import { create } from 'zustand';
import { batteriesAPI } from '@/api/batteries';
import type { Battery, BatterySummary, BatterySearchResult } from '@/types';

interface BatteryState {
  batteries: BatterySummary[];
  searchResults: BatterySearchResult[];
  suggestions: string[];
  selectedBattery: Battery | null;
  isLoading: boolean;
  isSearching: boolean;
  error: string | null;
  
  fetchBatteries: (params?: any) => Promise<void>;
  searchBatteries: (query: string) => Promise<void>;
  getBatteryById: (id: number) => Promise<void>;
  clearSearch: () => void;
  clearError: () => void;
}

export const useBatteryStore = create<BatteryState>((set) => ({
  batteries: [],
  searchResults: [],
  suggestions: [],
  selectedBattery: null,
  isLoading: false,
  isSearching: false,
  error: null,

  fetchBatteries: async (params) => {
    set({ isLoading: true, error: null });
    try {
      const response = await batteriesAPI.getAll(params);
      set({ 
        batteries: response.data.data.batteries, 
        isLoading: false 
      });
    } catch (error: any) {
      set({ 
        error: error.response?.data?.error?.message || 'فشل تحميل البطاريات',
        isLoading: false 
      });
    }
  },

  searchBatteries: async (query) => {
    if (!query.trim()) {
      set({ searchResults: [], suggestions: [] });
      return;
    }
    
    set({ isSearching: true, error: null });
    try {
      const response = await batteriesAPI.search(query);
      set({
        searchResults: response.data.data.batteries,
        suggestions: response.data.data.suggestions,
        isSearching: false,
      });
    } catch (error: any) {
      set({ 
        error: error.response?.data?.error?.message || 'فشل البحث',
        isSearching: false 
      });
    }
  },

  getBatteryById: async (id) => {
    set({ isLoading: true, error: null });
    try {
      const response = await batteriesAPI.getById(id);
      set({ 
        selectedBattery: response.data.data, 
        isLoading: false 
      });
    } catch (error: any) {
      set({ 
        error: error.response?.data?.error?.message || 'فشل تحميل البطارية',
        isLoading: false 
      });
    }
  },

  clearSearch: () => set({ searchResults: [], suggestions: [] }),
  clearError: () => set({ error: null }),
}));